<div *ngIf="horizontalMenu" class="navbar-header d-xl-block d-none">
  <!-- Navbar brand -->
  <ul class="nav navbar-nav flex-row">
    <li class="nav-item">
      <a class="navbar-brand" [routerLink]="['/']">
        <span class="brand-logo">
          <img src="{{ coreConfig.app.appLogoImage }}" alt="brand-logo" width="36" />
        </span>
        <h2 class="brand-text mb-0">{{ coreConfig.app.appName }}</h2>
      </a>
    </li>
  </ul>
  <!--/ Navbar brand -->
</div>

<div class="navbar-container d-flex content">
  <div class="bookmark-wrapper d-flex align-items-center">
    <!-- Menu Toggler | Menu icon will be hidden in case of layout without menu -->
    <ul class="nav navbar-nav d-xl-none" *ngIf="!coreConfig.layout.menu.hidden">
      <li class="nav-item">
        <a class="nav-link menu-toggle" (click)="toggleSidebar('menu')">
          <span [data-feather]="'menu'" [class]="'ficon'"></span>
        </a>
      </li>
    </ul>
    <!--/ Menu Toggler -->
    <!-- Bookmark -->
    <!-- <app-navbar-bookmark></app-navbar-bookmark> -->
    <!--/ Bookmark -->
    <app-navbar-company></app-navbar-company>
  </div>
  <ul class="nav navbar-nav align-items-center ml-auto">
    <!-- Language selection -->
    <!-- <li ngbDropdown class="nav-item dropdown dropdown-language">
      <a class="nav-link dropdown-toggle" id="dropdown-flag" ngbDropdownToggle>
        <i class="flag-icon flag-icon-{{ languageOptions[_translateService.currentLang].flag }}"></i
        ><span class="selected-language">{{ languageOptions[_translateService.currentLang].title }}</span></a
      >
      <div ngbDropdownMenu aria-labelledby="dropdown-flag">
        <a *ngFor="let lang of _translateService.getLangs()" ngbDropdownItem (click)="setLanguage(lang)">
          <i class="flag-icon flag-icon-{{ languageOptions[lang].flag }}"></i> {{ languageOptions[lang].title }}
        </a>
      </div>
    </li> -->
    <!--/ Language selection -->

    <!-- Search -->
    <!-- <app-navbar-search></app-navbar-search> -->
    <!--/ Search -->

    <!-- Cart -->
    <app-navbar-cart *ngIf="!isCheckoutRoute"></app-navbar-cart>
    <!--/ Cart -->

    <!-- Toggle skin -->
    <!-- <li class="nav-item d-none d-lg-block">
      <a class="nav-link nav-link-style btn" (click)="toggleDarkSkin()">
        <span [ngClass]="currentSkin === 'dark' ? 'icon-sun' : 'icon-moon'" class="ficon font-medium-5 feather"></span>
      </a>
    </li> -->
    <!--/ Toggle skin -->

    <!-- Notification -->
    <!-- <app-navbar-notification></app-navbar-notification> -->
    <!--/ Notification -->

    <!-- Entrar (quando não logado) -->
    <li
      class="nav-item d-flex align-items-center btn-entrar-wrapper"
      *ngIf="!currentUser"
      (click)="loginWithGoogle()"
    >
      <div id="google-btn" class="google-btn-overlay"></div>
      <span class="btn-entrar-label">
        <span [data-feather]="'log-in'" [class]="'mr-25'"></span>
        Entrar
      </span>
    </li>
    <!--/ Entrar -->

    <!-- User Dropdown (quando logado) -->
    <li ngbDropdown class="nav-item dropdown-user" *ngIf="currentUser">
      <a
        class="nav-link dropdown-toggle dropdown-user-link"
        id="navbarUserDropdown"
        ngbDropdownToggle
        aria-haspopup="true"
        aria-expanded="false"
      >
        <div class="user-nav d-sm-flex d-none text-right">
          <span class="user-name font-weight-bolder">
            {{ currentUser.firstName }}
          </span>
        </div>
        <span class="avatar">
          <img
            class="round"
            [src]="currentUser.avatar || 'assets/images/avatars/default.png'"
            alt="avatar"
            height="40"
            width="40"
            referrerpolicy="no-referrer"
          />
        </span>
      </a>
      <div ngbDropdownMenu aria-labelledby="navbarUserDropdown" class="dropdown-menu dropdown-menu-right user-dropdown-menu">
        <div class="dropdown-header">
          <div class="d-flex align-items-center">
            <img
              class="round mr-1 flex-shrink-0"
              [src]="currentUser.avatar || 'assets/images/avatars/default.png'"
              alt="avatar"
              height="40"
              width="40"
              referrerpolicy="no-referrer"
            />
            <div class="user-info text-truncate">
              <span class="font-weight-bolder d-block text-truncate">{{ currentUser.firstName }}</span>
              <small class="text-muted text-truncate d-block">{{ currentUser.email }}</small>
            </div>
          </div>
        </div>
        <div class="dropdown-divider"></div>
        <a ngbDropdownItem (click)="logout()"><span [data-feather]="'power'" [class]="'mr-50'"></span> Sair</a>
      </div>
    </li>
    <!--/ User Dropdown -->
  </ul>
</div>
